import { render, staticRenderFns } from "./staffsView.vue?vue&type=template&id=59821978&scoped=true"
import script from "./staffsView.vue?vue&type=script&lang=js"
export * from "./staffsView.vue?vue&type=script&lang=js"
import style0 from "./staffsView.vue?vue&type=style&index=0&id=59821978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59821978",
  null
  
)

export default component.exports